import { render, staticRenderFns } from "./HomeNotifications.vue?vue&type=template&id=3e3f3e2c&scoped=true&"
import script from "./HomeNotifications.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HomeNotifications.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HomeNotifications.vue?vue&type=style&index=0&id=3e3f3e2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3f3e2c",
  null
  
)

export default component.exports